import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerUserDetail,
	formatWorkerUserList,
} from './worker-user.helper';
import { WorkerUserActions } from './worker-user.redux';
import {
	IPayloadCreateWorkerUserRequest,
	IPayloadDeleteWorkerUserRequest,
	IPayloadGetWorkerUserDetailRequest,
	IPayloadGetWorkerUserListRequest,
} from './worker-user.type';

export function* getWorkerUserList(
	action: PayloadAction<IPayloadGetWorkerUserListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetWorkerUserListResponse> =
			yield API.getWorkerUserList({ searchTypes, ...rest });

		const content = formatWorkerUserList(res?.data?.content);

		yield put(
			WorkerUserActions.getWorkerUserListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUserActions.getWorkerUserListFailure());
	}
}

export function* createWorkerUsers(
	action: PayloadAction<IPayloadCreateWorkerUserRequest>
) {
	const { callback, ...props } = action.payload;

	try {
		yield API.createWorkerUser({
			...props,
		});

		yield put(WorkerUserActions.createWorkerUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUserActions.createWorkerUserFailure());
	}
}

export function* deleteWorkerUsers(
	action: PayloadAction<IPayloadDeleteWorkerUserRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerUser(ids);

		yield put(WorkerUserActions.deleteWorkerUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUserActions.deleteWorkerUserFailure());
	}
}

export function* getWorkerUserDetail(
	action: PayloadAction<IPayloadGetWorkerUserDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IWorkerUser> =
			yield API.getWorkerUserDetail(id);

		const workerUserDetail = formatWorkerUserDetail(res.data);

		yield put(
			WorkerUserActions.getWorkerUserDetailSuccess({
				workerUserDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUserActions.getWorkerUserDetailFailure());
	}
}
